module.exports = __webpack_public_path__ + "static/assets/d1b90508911e39a55081cb8ee6bdc1f6.png";